import { render, staticRenderFns } from "./OssUpload.vue?vue&type=template&id=60495768&"
import script from "./OssUpload.vue?vue&type=script&lang=js&"
export * from "./OssUpload.vue?vue&type=script&lang=js&"
import style0 from "./OssUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports